import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { MeasurementTypes } from "src/api/types";

interface Props {
  measurements: MeasurementTypes;
}

const WeightProgress = ({ measurements }: Props) => {
  const { t } = useTranslation();
  const component = "weight-tracker";

  const allTime = useMemo(() => {
    const diff = measurements.starting - (measurements.current || 0);

    return diff;
  }, [measurements]);

  const direction = useMemo<"up" | "down" | "none">(() => {
    if (allTime > 0) return "down";
    if (allTime < 0) return "up";

    return "none";
  }, [allTime]);

  const color = useMemo(() => {
    switch (direction) {
      case "down":
        return "#3BB273";
      case "up":
        return "#D32F2F";
      default:
        return "text.secondary";
    }
  }, [direction]);

  return (
    <Stack direction={"row"} alignItems={"center"} spacing={0.5}>
      {direction === "down" ? (
        <ArrowDownward fontSize="small" sx={{ color: color }} />
      ) : direction === "up" ? (
        <ArrowUpward fontSize="small" sx={{ color: color }} />
      ) : null}
      <Typography variant="subtitle1" color={color}>
        {Math.abs(allTime).toFixed(1)} lbs
      </Typography>
      <Typography variant="subtitle1">
        {t(`${component}.all-time`, "All-time")}
      </Typography>
    </Stack>
  );
};

export default WeightProgress;
